<template>
  <v-chart class="chart" :option="option" />
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";
import { ref, defineComponent } from "vue";

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
]);

export default defineComponent({
  name: "Auprc",
  props: ['instance', 'sample', 'rank'],
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  },
  created() {
    fetch(`data/${this.instance}.auprc.json`)
      .then(res => {
        const json_data=res.json();
        return json_data
        })
      .then(json_data => this.create_plot(json_data, this.$props.rank))
  },
  watch: {
    rank (val) {
      this.create_plot(this.json_data, val)
    }
  },
  data () {
    return {
      option: {
        },
      json_data: {},
      plot_data: [],
      labels: []
    }
  },
  methods: {
    create_plot (json_data, rank) {
        // keep the loaded data
        this.json_data=json_data
        // set the filtered data
        this.filtered_data=this.json_data
        this.plot_data = []
        this.labels = []
        for(var i in Object.keys(json_data.toolname)) {
          if (json_data.sample[i] == this.sample){
            if (json_data.rank[i] == rank){
                this.plot_data.push(json_data.value[i])
                this.labels.push(json_data.toolname[i])
            }
          }
        }
        this.option = ref({
            title: {
                text: 'Area under the precision-recall curve\nat the '+this.rank+' rank',
                left: 'center',
                textStyle: {
                fontSize: 14
                }
            },
            yAxis: {
              type: 'category',
              data: this.labels
            },
            xAxis: {
                type: 'value',
                max: 1.0
            },
            grid: {
                right: '5%',
                bottom: '0%',
                containLabel: true
            },
            series: [{
                data: this.plot_data,
                type: 'bar',
                showBackground: true,
                backgroundStyle: {
                    color: 'rgba(180, 180, 180, 0.2)'
                },
                color: 'teal'
            }]
        });
      }
  }
});
</script>

<style scoped>
.chart {
  height: 400px;
}
</style>
